import { CommonModule } from '@angular/common';
import { Component, inject, computed } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from 'src/app/header/header.component';
import { FooterComponent } from 'src/app/footer/footer.component';
import { LeftBannerComponent } from 'src/app/left-banner/left-banner.component';
import { RouteDataService } from './route-data.service';
import { HttpClientModule } from '@angular/common/http';
import { DashboardHeaderComponent } from '@booking/dashboard/dashboard-header/dashboard-header.component';
import { AuthenticationService } from '@core/services/auth.service';
import { SpinnerComponent } from '@core/components/spinner.component';
import { SpinnerService } from '@core/services/spinner.service';
import { ToastComponent } from '@core/components/toast.component';
import { MessageService } from '@core/services/message.service';
import { ModalService } from '@core/services/modal.service';
import { ModalComponent } from "./core/components/modals/modal.component";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  imports: [
    RouterOutlet,
    HeaderComponent,
    FooterComponent,
    LeftBannerComponent,
    CommonModule,
    HttpClientModule,
    DashboardHeaderComponent,
    SpinnerComponent,
    ToastComponent,
    ModalComponent
  ],
  providers: [],
  standalone: true,
})
export class AppComponent {
  private routeDataService = inject(RouteDataService);
  private auth = inject(AuthenticationService);
  private routeLayoutData = computed(() => this.routeDataService.routeLayoutData());
  private spinnerService = inject(SpinnerService);
  private messageService = inject(MessageService);
  private modalService = inject(ModalService);

  isLogged(){
    return this.auth.isLogged();
  }

  showHeader(){
    return !this.routeLayoutData().hideHeader;
  }

  showFooter(){
    return !this.routeLayoutData().hideFooter;
  }

  showBanner(){
    return !!this.routeLayoutData().leftBanner;
  }

  isLoading(){
    return this.spinnerService.loadingState();
  }

  showTostMessage(){
    return this.messageService.showMessage();
  }

  showModal(){
    return this.modalService.showModal();
  }

  getMessage = computed(() => this.messageService.getMessage())

  getMessageType = computed(() => this.messageService.getType())

  getModalMessage = computed(() => this.modalService.getMessage())

  getModalType = computed(() => this.modalService.getType())
}
